import _ from 'lodash';
import { split } from 'lodash-es';

import cms from './errorFields/cms';
import book from './errorFields/book';
import linkBlockAppDeepLink from './errorFields/linkBlockAppDeepLink';
import inbox from './errorFields/inbox';
import memberTransaction from './errorFields/memberTransaction';

const getErrorFieldsMappingI18n = (intl, moduleName, methodName) => {
  switch (moduleName) {
    case 'cms':
      return cms(intl, methodName);
    case 'book':
      return book(intl, methodName);
    case 'linkBlockAppDeepLink':
      return linkBlockAppDeepLink(intl, methodName);
    case 'inbox':
      return inbox(intl, methodName);
    case 'memberTransaction':
      return memberTransaction(intl, methodName);

    default:
      return {};
  }
};

const translateErrorFields = (intl, errorMessages, moduleName, methodName) => {
  const fieldsMappingI18n = getErrorFieldsMappingI18n(intl, moduleName, methodName);

  return _.map(errorMessages, errorMessage => {
    // 透過比對特殊跳脫字元 '$(任意字元)', 尋找該錯誤訊息是否存在須轉換的錯誤欄位.
    const errorFields = errorMessage.split(/\$\((.*?)\)/g).filter((row, key) => key % 2 !== 0);
    if (errorFields.length > 0) {
      _.each(errorFields, errorField => {
        let errorFieldMappingI18n = '';

        // 區分該錯誤欄位是否為多層結構, ex: cms.0.linkblock.......
        const fieldSplitArray = split(errorField, '.');
        if (fieldSplitArray.length > 1) {
          let fieldSplitKey = _.first(fieldSplitArray);
          let chapterIndex = parseInt(fieldSplitArray[1]) + 1;
          errorFieldMappingI18n += ` [${_.get(
            fieldsMappingI18n,
            fieldSplitKey,
            fieldSplitKey,
          )}${chapterIndex}]的`;

          for (let i = 4; i <= fieldSplitArray.length; i += 2) {
            fieldSplitKey += `.${fieldSplitArray[i - 2]}`;
            errorFieldMappingI18n += `[第${parseInt(fieldSplitArray[i - 1]) + 1}個${_.get(
              fieldsMappingI18n,
              fieldSplitKey,
              fieldSplitKey,
            )}]的`;
          }

          fieldSplitKey = `${fieldSplitKey}.${_.last(fieldSplitArray)}`;
          errorFieldMappingI18n += ` [${_.get(fieldsMappingI18n, fieldSplitKey, fieldSplitKey)}] `;
        } else {
          errorFieldMappingI18n = ` [${_.get(fieldsMappingI18n, errorField, errorField)}] `;
        }

        errorMessage = errorMessage.replace(`$(${errorField})`, errorFieldMappingI18n);
      });
    }

    return errorMessage;
  });
};

export default translateErrorFields;
